// @flow
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import type { State as ForgotPasswordState } from '@redux/components/ForgotPassword/types';
import { StyledLabel } from '@styles/labels';
import { StyledButton } from '@styles/buttons';
import { requestForgotPassword } from '@redux/components/ForgotPassword/actions';
import { withTranslation } from 'react-i18next';
import { DarkCrossIcon } from '@images/svg/index';
import type { GlobalState } from '@globalTypes';
import type { Props } from './types';

import { StyledInput, StyledButtonsContainer } from '../LoginForm/styles';

import {
  StyledCover,
  StyledHeading,
  StyledText,
  StyledIconWrapper,
  StyledInputWrapper,
  StyledBody
} from './styles';

const ForgotPasswordForm = ({
  forgotPassword,
  requestForgotPassword,
  setPassword,
  t
}: Props): React.Node => {
  const [email, setEmail] = React.useState('');
  const { error, success, requesting }: ForgotPasswordState = forgotPassword;
  const ButtonLogin = StyledButton;

  const submitFn = (): void => requestForgotPassword(email);

  return (
    <div>
      <StyledCover>
        <StyledBody>
          <StyledIconWrapper>
            <DarkCrossIcon onClick={() => setPassword(false)} />
          </StyledIconWrapper>
          {success ? (
            <StyledHeading center>{t('ForgotPassword.SuccessHeading')}</StyledHeading>
          ) : (
            <StyledHeading>{t('ForgotPassword.Heading')}</StyledHeading>
          )}

          <StyledText center={success}>
            {success ? t('ForgotPassword.SuccessText') : t('ForgotPassword.Text')}
          </StyledText>

          {success && <StyledText center>{t('ForgotPassword.SuccessText2')}</StyledText>}

          {!success && (
            <StyledInputWrapper>
              <StyledLabel htmlFor="password_confirmation" required>
                {t('Email')}
              </StyledLabel>
              <StyledInput
                type="text"
                value={email}
                onChange={event => setEmail(event.target.value)}
                error={error}
                greyblue
              />
            </StyledInputWrapper>
          )}

          <StyledButtonsContainer>
            {!success && (
              <ButtonLogin onClick={submitFn} width disabled={requesting}>
                {t('ForgotPassword.Submit')}
              </ButtonLogin>
            )}
          </StyledButtonsContainer>
        </StyledBody>
      </StyledCover>
    </div>
  );
};

const mapStateToProps = (state: GlobalState) => ({
  forgotPassword: state.forgotPassword
});

const mapDispatchToProps = { requestForgotPassword };

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withTranslation('Login')
)(ForgotPasswordForm);
